import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class GetCartOffers extends Event {
    eventName = 'oms_getCartOffers';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get Cart Offers
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let multiCallKey = (data.multi_call_key) ? data.multi_call_key : 'cart_offers';

        let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
        let selectedProducts = new LocalStorage.CartLocation(currentLocation).getData();
        let products = [];

        if (selectedProducts && Object.keys(selectedProducts).length > 0) {
            products = Object.keys(selectedProducts).map( id => { 
                return {"id": id, "count": selectedProducts[id].item_qty}; 
            });
        }

        let orderDetails = new LocalStorage.OrderDetails(clientId).getData();

        if (orderDetails?.data) {
            orderDetails = orderDetails.data;
        }

        //shipping address
        let shippingAddress = {
            "address": data.address,
            "state": data.state,
            "country": data.country_code,
            "city": data.city,
            "zip": data.postal_code,
            "location_id": currentLocation,
            "region": (orderDetails?.delivery_info) ? orderDetails.delivery_info.region : null
        }

        // request data
        data.endPoint = application_settings.endPoints.getCartOffers;
        data.multi_call_key = multiCallKey;
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            address: data.address,
            city: data.city,
            contact_number: data.contact_number,
            country: data.country,
            name: data.name,
            email: data.email,
            delivery_date: data.delivery_date,
            order_instruction: data.order_instruction,
            shipping_address: data.address,
            shipping_city: data.city,
            shipping_country: data.country,
            state: data.state,
            type: data.order_type,
            location_id: currentLocation,
            products: JSON.stringify(products),
            payment_method: data.payment_method,
            shipping_method: (orderDetails?.delivery_info) ? orderDetails.delivery_info.deliveryMethod : null,
            discount_code: (data.discount_code) ? data.discount_code : null,
            main_method_code: (orderDetails?.delivery_info) ? orderDetails.delivery_info.deliveryMainMethod : null,
            shipping_address_info: JSON.stringify(shippingAddress),
            flash_delivery: data.flash_delivery,
            order_currency: data.order_currency
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
        
    }
}

export default GetCartOffers;